module.exports = __webpack_public_path__ + "static/organicpastelelephant-13c0cae88f8180539a01cf1e18f35913.jpeg";